<template lang="pug">
.Sidebar
  router-link(to="/" exact).logo: Logo
  //- (@click="$store.commit('toggleGrid')"): Logo
  nav
    router-link(to="/about" key="about") About
    template(v-if="this.page !== 'singleWork'")
      router-link(to="/work" key="work") Work
    template(v-else)
      router-link(to="/work" v-html="splitting" key="singleWork") Back
    router-link(to="/" exact key="home") Home

</template>

<script>
import 'splitting/dist/splitting.css'
import 'splitting/dist/splitting-cells.css'
import Splitting from 'splitting'
import { hoverEffect } from '../assets/scripts/utils'
import Logo from '@/components/Logo'

export default {
  name: 'Sidebar',
  components: { Logo },
  props: {
    currentPage: {
      type: String
    }
  },
  data() {
    return {
      splitting: '',
      page: this.currentPage
    }
  },
  methods: {
    split(word) {
      this.splitting = Splitting.html({
        content: `${word}`,
        by: 'chars'
      })
    }
  },
  watch: {
    currentPage(newPage, oldPage) {
      console.log(newPage)
      this.page = newPage
      if (newPage === 'singleWork') {
        this.split('Back')
        setTimeout(() => {
          hoverEffect(true)
        }, 1500)
      }
    }
  }
}
</script>

<style lang="scss">
.Sidebar {
  @include grid(0, 1);
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 90vh;
  z-index: 3;

  @include desktop {
    @include grid(0, 2);
    position: fixed;
    height: 98vh;
  }

  .logo {
    text-decoration: none;
    color: black;

    .Logo {
      text-decoration: none;
      display: inline-block;
    }
  }

  .slide-fade-enter-to {
    opacity: 1;
  }
  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter, .slide-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    /* transform: translateY(10px); */
    opacity: 0;
  }

  nav {
    transform-origin: top left;
    transform: rotate(-90deg);
    white-space: nowrap;
    font-size: $fs-l;

    @media screen and (max-width: 870px) {
      margin-bottom: -1.5rem;
    }

    a {
      line-height: 1em;
      display: inline-block;
      vertical-align: top;
      margin-right: 2rem;
      @include invisible-link;
      opacity: 0.1;
      transition: 0.5s $ease-out;
      font-weight: bold;
      width: 4rem;
      text-align: center;

      @media screen and (max-width: 870px) {
        margin-right: 1.2rem;
      }

      &:hover {
        opacity: 0.5;
      }

      &.router-link-active {
        opacity: 1;
      }
    }
  }
}
</style>
